
import moment from 'moment';
import Vue from 'vue';
export default {
  name: 'HoverComponent',
  props: {
    top: { type: String, default: '50px' },
    left: { type: String, default: '100px' },
    color: { type: String, default: '#4a00e0' }
  },
  data() {
    return {
      hover: false,
      enableHoverEvents: false,
      showInitially: false,
      modalData: {}
    };
  },
  computed: {
    yesterdayDate() {
      return moment()
        .subtract(1, 'day')
        .format('YYYY/MM/DD');
    },
    todayDate() {
      return moment().format('YYYY/MM/DD');
    },
    activeDate() {
      const slot = this.modalData.button_submit_prompt;
      return slot === 'today_progress' ? this.todayDate : this.yesterdayDate;
    },
    isModalDisabledForTenant() {
      return localStorage.getItem('tenentID') === 'Y2ZkjDDEzWz7Nr5KS';
    },
    positionStyle() {
      return {
        position: 'absolute',
        top: this.top,
        left: this.left,
        zIndex: 1000,
        backgroundColor: this.color
      };
    }
  },
  mounted() {
    this.onHoverMethod();
  },
  methods: {
    handleChat() {
      const matches = Object.entries(this.$store.state.target.prompts).filter(
        ([key, p]) => {
          return (
            p.botname === this.modalData?.button_submit_prompt &&
            key.startsWith('Dashboard') &&
            key !== 'Dashboard'
          );
        }
      );
      if (matches.length > 0) {
        const [matchedKey, matchedPrompt] = matches[0];
        this.notNowHandle('view _summary');
        window.handlePromptClick(matchedPrompt, 'Modal Shown');
      }
    },
    notNowHandle(button) {
      this.hover = false;
      this.enableHoverEvents = true;
      this.showInitially = false;
      localStorage.setItem(
        `reset_${this.modalData?.button_submit_prompt}`,
        true
      );
      const profile = this.$store.state.user.profile;
      Vue.prototype.$mixpanel?.track('Modal Button Clicked', {
        email: profile?.email,
        promptName: this.modalData?.button_submit_prompt,
        modal_type:
          this.modalData?.button_submit_prompt === 'morning_brief'
            ? 'morning'
            : 'afternoon',
        button
      });
    },
    onHoverMethod() {
      const translationData = this.$store.state.user.translate;
      const activeKeys = this.getActiveModelKeys(translationData);
      const modifyKeys = this.stripModalPrefix(activeKeys);
      //   
      const obj = this.isWithinTriggerTime(modifyKeys);
      const profile = this.$store.state.user.profile;
      //   
      if (obj?.trigger && obj?.data?.button_submit_prompt) {
        const today = new Date().toISOString().split('T')[0];
        const storedDate = localStorage.getItem('appDate');
        // Reset keys if a new day
        if (storedDate !== today) {
          Object.keys(localStorage).forEach(key => {
            if (key.startsWith('reset_')) {
              localStorage.removeItem(key);
            }
          });
          localStorage.setItem('appDate', today);
        }

        // Check if this button was previously reset
        const resetKey = `reset_${obj.data.button_submit_prompt}`;
        const enable = localStorage.getItem(resetKey);
        this.enableHoverEvents = enable;

        if (!this.enableHoverEvents) {
          this.hover = true;
          this.showInitially = true;
        }
      }

      // Replace placeholders in modal title
      if (modifyKeys?.title) {
        modifyKeys.title = modifyKeys.title
          .replace('[first name]', profile?.firstName || '')
          .replace('[last name]', profile?.lastName || '');
        //
        this.modalData = modifyKeys;
      }
    },

    isWithinTriggerTime(time) {
      if (!time?.trigger_time) return;
      // Example input: "05PM-08PM"
      const [startStr, endStr] = time?.trigger_time?.split('-');

      // Convert to moment objects for today
      const now = moment();
      const start = moment(startStr, 'hhA');
      const end = moment(endStr, 'hhA');

      // Adjust to today's date
      start.set({ year: now.year(), month: now.month(), date: now.date() });
      end.set({ year: now.year(), month: now.month(), date: now.date() });

      // Handle overnight ranges (e.g., 10PM-02AM)
      if (end.isBefore(start)) {
        end.add(1, 'day');
      }

      return { trigger: now.isBetween(start, end), data: time };
    },
    stripModalPrefix(obj) {
      const result = {};
      for (const key in obj) {
        const newKey = key.replace(/^modal_\d+_/, '');
        result[newKey] = obj[key];
      }
      return result;
    },
    isNowInRange(triggerTime) {
      const [start, end] = triggerTime
        .toUpperCase()
        .replace(/\s+/g, '')
        .split('-');

      const now = moment();
      const startTime = moment(start, ['hhA']);
      const endTime = moment(end, ['hhA']);

      // Case when end is before start (e.g., 10PM-2AM)
      if (endTime.isBefore(startTime)) {
        return now.isAfter(startTime) || now.isBefore(endTime);
      } else {
        return now.isBetween(startTime, endTime);
      }
    },
    getActiveModelKeys(obj) {
      let activePrefix = null;
      for (const key of Object.keys(obj)) {
        const match = key.match(/^modal_(\d+)_trigger_time$/);
        if (match) {
          const trigger = obj[key];
          if (this.isNowInRange(trigger)) {
            activePrefix = `modal_${match[1]}`;
            break;
          }
        }
      }

      if (!activePrefix) return {};

      return Object.keys(obj)
        .filter(k => k.startsWith(activePrefix))
        .reduce((acc, k) => {
          acc[k] = obj[k];
          return acc;
        }, {});
    }
  }
};
